/* src/utils/formatters.js
   --------------------------------------------------------------
   Funzioni riutilizzabili per formattare numeri e valute nello
   stile “it-IT” (es. 1.234,56  –  1.234,56 €  –  18,00 %).      */

const dec = (min = 2, max = 2) => ({
  minimumFractionDigits: min,
  maximumFractionDigits: max,
});

const it = new Intl.NumberFormat('it-IT');                   // interi
const itDec = new Intl.NumberFormat('it-IT', dec());         // 2 dec.
const itCurr = new Intl.NumberFormat('it-IT', {              // €.€
  style: 'currency',
  currency: 'EUR',
  ...dec(),
});

const itPercent = new Intl.NumberFormat('it-IT', {
  style: 'percent',
  ...dec(2, 2),
});

export const fmtInt      = n => it.format(Math.round(n ?? 0));
export const fmtNumber   = n => itDec.format(n ?? 0);
export const fmtCurrency = n => itCurr.format(n ?? 0);
export const fmtPercent  = n => itPercent.format((n ?? 0) / 100);
